import axios from "axios";

const API_BASE_URL = "https://apem.riderup.uk/api";

export const fetchSearchResults = async (query, clientId = 0, mode = "youtube") => {
    if (!query) {
        return [];
    }

    try {
        const response = await axios.get(`${API_BASE_URL}/youtube/search`, {
            params: { query, bar: clientId || 0, mode },
        });

        return response.data || [];
    } catch (error) {
        console.error("Erro ao buscar resultados de pesquisa:", error.message);
        return [];
    }
};

export const fetchTrendingVideos = async () => {
    return [];
};
